import { TASK_STATUS } from '../../../../constants/activityCenter';

/**
 * Check if a task status represents an active (in-progress or queued) task
 * @param {string} status - The task status to check
 * @returns {boolean} True if the task is active
 */
export const isActiveStatus = (status) => status === TASK_STATUS.IN_PROGRESS || status === TASK_STATUS.QUEUED;

/**
 * Check if a task status represents a completed (completed or failed) task
 * @param {string} status - The task status to check
 * @returns {boolean} True if the task is completed
 */
export const isCompletedStatus = (status) => status === TASK_STATUS.COMPLETED || status === TASK_STATUS.FAILED;

/**
 * Format a date string for display in the Activity Center
 * @param {string} dateString - The ISO date string to format
 * @returns {string} Formatted date string
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateString));
};
